import { useTranslation } from 'react-i18next'

import useStyles from './DemoBadge.styles'

const DemoBadge = () => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <div
      className={classes.badge}
      title={t(
        `Demo products are fully functional except you can't download the trained model.`
      )}
    >
      {t('Demo')}
    </div>
  )
}

export default DemoBadge
